import { FilterOptionType } from 'src/components/RealityCheckForm/CustomDropdown';
import {
    SourceOfFundsCalculationType,
    SourceOfFundsCalendarPeriodValueType,
    SourceOfFundsPeriodType,
} from 'src/components/ComplianceConfiguration/SourceOfFunds/SourceOfFunds.types';

export const SOURCE_OF_FUNDS_COMPLIANCE_RESTRICTION_OPTIONS_ARRAY: Array<FilterOptionType<string>> = [
    { value: '7', label: '7 days' },
    { value: '14', label: '14 days' },
    { value: '30', label: '30 days' },
];

export const DEFAULT_SOURCE_OF_FUNDS_COMPLIANCE_RESTRICTION_PERIOD =
    SOURCE_OF_FUNDS_COMPLIANCE_RESTRICTION_OPTIONS_ARRAY[0]?.value ?? '7';

export const DEFAULT_SOURCE_OF_FUNDS_THRESHOLD_AMOUNT = '50000';

export const DEFAULT_SOURCE_OF_FUNDS_NEW_ACCOUNT_AMOUNT = '20000';

export const DEFAULT_SOURCE_OF_FUNDS_NEW_ACCOUNT_DAYS_SINCE_SIGNUP = '90';

export const DEFAULT_SOURCE_OF_FUNDS_NEW_ACCOUNT_DEPOSIT_WINDOW_DAYS = '90';

export const SOURCE_OF_FUNDS_CALCULATION_TYPE_OPTIONS_ARRAY: Array<FilterOptionType<SourceOfFundsCalculationType>> = [
    { value: 'net', label: 'Net' },
    { value: 'gross', label: 'Gross' },
];

export const SOURCE_OF_FUNDS_PERIOD_TYPE_OPTIONS_ARRAY: Array<FilterOptionType<SourceOfFundsPeriodType>> = [
    { value: 'rolling', label: 'Rolling' },
    { value: 'calendar', label: 'Calendar' },
];

export const DEFAULT_SOURCE_OF_FUNDS_ROLLING_PERIOD_DAYS = '365';

export const SOURCE_OF_FUNDS_CALENDAR_PERIOD_OPTIONS_ARRAY: Array<
    FilterOptionType<SourceOfFundsCalendarPeriodValueType>
> = [
    { value: '1', label: 'Day' },
    { value: '7', label: 'Week' },
    { value: '30', label: 'Month' },
    { value: '90', label: 'Three Months' },
    { value: '365', label: 'Year' },
];

export const DEFAULT_SOURCE_OF_FUNDS_CALENDAR_PERIOD_VALUE: SourceOfFundsCalendarPeriodValueType = '30';

export const isSourceOfFundsCalculationType = (value: string): value is SourceOfFundsCalculationType => {
    return SOURCE_OF_FUNDS_CALCULATION_TYPE_OPTIONS_ARRAY.some((option) => option.value === value);
};

export const isSourceOfFundsPeriodType = (value: string): value is SourceOfFundsPeriodType => {
    return SOURCE_OF_FUNDS_PERIOD_TYPE_OPTIONS_ARRAY.some((option) => option.value === value);
};

export const isSourceOfFundsCalendarPeriodValue = (value: string): value is SourceOfFundsCalendarPeriodValueType => {
    return SOURCE_OF_FUNDS_CALENDAR_PERIOD_OPTIONS_ARRAY.some((option) => option.value === value);
};
